export const validationUtils = {
  methods: {
    emailIsValid(val) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(val).toLowerCase());
    },
    validateMobilePhone(val) {
      return val.match(/^[+][(]?[0-9]{1,3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,7}$/gm);
    },
    validateFaxNumber(val) {
      const re = /^\+?[0-9]+$/;
      return re.test(val);
    },
    validateOnlyNumbersAndSpaces(val) {
      const re = /^[0-9 ]+$/;
      return re.test(val);
    },
    stringContainsOnlyWhitespaces(val) {
      return !val.replace(/\s/g, "").length;
    }
  }
};
